import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flq",
  "use": "icon-flq-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flq\">\n<defs>\n  <style type=\"text/css\"></style>\n</defs>\n<path d=\"M890.88 737.28a320 320 0 0 0-169.6-499.84v-147.2H0v160h512a320 320 0 0 0-144 120.32H0V531.2h316.16v14.08a325.12 325.12 0 0 0 18.56 106.24H0v160h458.88a316.16 316.16 0 0 0 176.64 53.76 320 320 0 0 0 192-64L960 933.76l32-32 32-32z m-458.24-85.76a229.12 229.12 0 0 1-26.88-106.24V531.2a229.76 229.76 0 0 1 82.56-160.64 225.92 225.92 0 0 1 147.2-55.04 229.76 229.76 0 0 1 85.76 442.88 222.72 222.72 0 0 1-85.76 16.64 230.4 230.4 0 0 1-202.88-123.52z\" p-id=\"15004\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/flq.svg
// module id = U+7C
// module chunks = 13